import { Grid } from '@mui/material';
import React from 'react';
import { useTheme } from '@mui/material/styles';
import EirFooter from '../../../../../components/eir-footer/EirFooter';
import EirHeader from '../../../../../components/eir-header/EirHeader';
import EirMetaTag from '../../../../../components/eir-meta-tag/EirMetaTag';
import FaqContainer from '../../../../../components/eir-mobile-broadband/FaqContainer';
import getStrapiData from '../../../../../integration/strapi';
import PrepayHandsetDetailsContainer from '../../../../../components/eir-prepay/prepay-handset-details/PrepayHandsetDetailsContainer';
import useStyles from '../../../../../components/eir-prepay/prepay-handset-details/styles';

export async function getServerSideProps() {
  let cmsHeaderData = {};
  let cmsFooterData = {};
  const cmsData = await getStrapiData('prepay-handset-detail');
  cmsHeaderData = await getStrapiData('header');
  cmsFooterData = await getStrapiData('footer');

  return {
    props: {
      cmsData: cmsData?.data,
      cmsHeaderData,
      cmsFooterData,
    },
  };
}

/**
 * @name PrepayHandsetDetails
 * @description Page which loads prepay handset details journey
 * @param {object} cmsData - Strapi object for prepay-mobile
 * @param {object} cmsHeaderData - Strapi object for header
 * @param {object} cmsFooterData - Strapi object for footer
 * @returns {JSX.Element} - Returns Prepay handset details Page
 */
const PrepayHandsetDetails = ({ cmsData, cmsHeaderData, cmsFooterData }) => {
  const theme = useTheme();
  const style = useStyles(theme);
  return (
    <>
      <EirMetaTag seo={cmsData?.attributes?.seoHandsetDetails} />
      <EirHeader cmsHeaderData={cmsHeaderData?.data} />
      <main id='main' tabIndex={-1}>
        <PrepayHandsetDetailsContainer cmsDataPrepay={cmsData} />
        {cmsData?.data?.attributes?.handsetDetailsFaqList?.length > 0 && (
          <Grid xs={12} sx={style.faqContainerSuperMain}>
            <FaqContainer
              InsuranceHeading={cmsData?.data?.attributes?.handsetDetailsFaqTitle}
              InsuranceList={cmsData?.data?.attributes?.handsetDetailsFaqList}
            />
          </Grid>
        )}
      </main>
      <EirFooter cmsFooterData={cmsFooterData?.data} />
    </>
  );
};

export default PrepayHandsetDetails;
